<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Add Vendor</h4>
            <div [formGroup]="vendorForm" class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Company Name</label>
                        <input formControlName="name" type="text" class="form-control">
                    </div>
                </div>
           
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>Contact Person Name</label>
                        <input formControlName="contactName" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>Contact Person Phone</label>
                        <input formControlName="contactPhone" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>Contact Person Email</label>
                        <input formControlName="contactEmail" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>Code</label>
                        <input formControlName="code" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>Type</label>
                        <input formControlName="type" type="text" class="form-control">
                    </div>
                </div>
    

                <div class="col-sm-12 col-md-13 col-lg-12" *ngFor="let key of keyValueList">
                    <div class="form-group">
                        <label>{{key.key}}</label>
                        <input *ngIf="key.boxType == 'Input'" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="key.value" type="text" class="form-control">
                        <select *ngIf="key.boxType == 'Dropdown'" class="form-control" name="" id="" [ngModelOptions]="{standalone: true}" [(ngModel)]="key.value">
                            <option [value]="possibleValue" *ngFor="let possibleValue of key.possibleValue">{{possibleValue}}</option>
                        </select>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12">
                    <label>Address</label>
                    <div class="row addresse-block">
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Name</label>
                                <input [(ngModel)]="geoAddress.name" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Phone</label>
                                <input [(ngModel)]="geoAddress.phone1" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Email</label>
                                <input [(ngModel)]="geoAddress.email" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Address</label>
                                <input [(ngModel)]="geoAddress.address" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Landmark</label>
                                <input [(ngModel)]="geoAddress.landmark" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>City</label>
                                <input [(ngModel)]="geoAddress.city" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Town</label>
                                <input [(ngModel)]="geoAddress.town" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>District</label>
                                <input [(ngModel)]="geoAddress.district" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>Post Code</label>
                                <input [(ngModel)]="geoAddress.postCode" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <div class="form-group">
                                <label>State</label>
                                <input [(ngModel)]="geoAddress.state" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group image-b" *ngIf="vendorForm.controls['image'].value == ''">
                        <label>Image </label>
                        <button class="" (click)="imageButtonClick()">Add Image</button>
                        <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*" [style.display]="'none'">
                    </div>
                    <div class="form-group image-view" *ngIf="vendorForm.controls['image'].value != ''">
                        <label>Image </label>
                        <img [src]="vendorForm.controls['image'].value" alt="" srcset="">
                        <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group image-b">
                        <label>Document </label>
                        <button class="" (click)="docButtonClick()">Add</button>
                        <input type="file" id="DocInput" (change)="onChangeDoc($event)" accept="image/*" [style.display]="'none'">
                    </div>
                    <div *ngIf="documents.length != 0" class="doc-image-view">
                        <div *ngFor="let doc of documents" >
                            <div class="" *ngIf="doc.type == 'image/png' || doc.type == 'image/jpeg'">
                                <img [src]="doc.url" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="addVendor()" class="btn btn-primary">Add</button>
            </div>
        </div>
    </div>
</div>